import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: 120,
    height: 120,
    margin: '0 auto',
    fontSize: 10,
  },
}));

const AvatarComponent = (props) => {
  const { src = '', alt = '상품 이미지', variant = 'rounded', ...rest } = props;
  const classes = useStyles();
  // 외부 이미지 안나오는 현상 해결하기위한 내부 cdn 주소 추가
  let newSrc = !!src
    ? src.startsWith('http://')
      ? '//img.en-mobon.com/?src=' + src
      : src
    : src;
  if (!!newSrc) {
    // http 혹은 https 추가되지않는 경로가 들어왓을 떄 https추가하는 조건 추가
    if (!newSrc.startsWith('http://') && !newSrc.startsWith('https://')) {
      newSrc = 'https://' + newSrc;
    }
  }

  return (
    <Avatar
      variant={variant}
      alt={alt}
      src={newSrc}
      className={classes.avatar}
      {...rest}
    >
      {!src && 'No img'}
    </Avatar>
  );
};

export default AvatarComponent;
